export default __webpack_public_path__ + "static/inground-pool-removal-icon-bf253b0dc536744a346aeb1a47f3af81.png";